import { useState, useEffect, RefObject } from 'react'

export const useIsScrolling = (
  scrollableContainerRef: RefObject<HTMLDivElement | null>
) => {
  const [isScrolling, setIsScrolling] = useState(false)

  useEffect(() => {
    if (!scrollableContainerRef.current) return

    let timeoutId: ReturnType<typeof setTimeout> | null = null

    const handleScroll = () => {
      setIsScrolling(true)
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      timeoutId = setTimeout(() => {
        setIsScrolling(false)
      }, 150) // Adjust the debounce delay as needed
    }

    const node = scrollableContainerRef.current
    node.addEventListener('scroll', handleScroll)

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      node.removeEventListener('scroll', handleScroll)
    }
  }, [scrollableContainerRef])

  return isScrolling
}
